import { defineMessages } from 'react-intl'

export const findDealerHelpMessages = defineMessages({
  title: {
    id: 'findDealerHelp.title',
    description: 'Text about Find a Dealer',
    defaultMessage: 'Find a Dealer',
  },
  extendedText: {
    id: 'findDealerHelp.extendedText',
    description: 'Text about explains what dealer does',
    defaultMessage:
      'Connect with a trusted Savant Dealer near you. Our network of certified professionals can assist with service or enhancements for your Savant Home.',
  },
  findDealer: {
    id: 'findDealerHelp.findDealerButton',
    description: 'Text about `findDealer` button',
    defaultMessage: 'Find a Dealer',
  },
})
